var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeycard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.005,
    height: 19.515,
    viewBox: "0 0 32.005 19.515",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19179",
    "data-name": "Group 19179",
    transform: "translate(-87.5 -287.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_247840",
    "data-name": "Path 247840",
    d: "M117.553,287.5h-28.1a1.952,1.952,0,0,0-1.952,1.952v15.612a1.952,1.952,0,0,0,1.952,1.952h28.1a1.952,1.952,0,0,0,1.951-1.952V289.452A1.952,1.952,0,0,0,117.553,287.5Zm-29.273,3.9h2.88l-1.171,2.342h-1.71Zm3.271,2.342h-.687l1.171-2.342h.687ZM93.6,291.4h.687l-1.171,2.342h-.687Zm25.128,13.661a1.169,1.169,0,0,1-1.171,1.171h-28.1a1.169,1.169,0,0,1-1.171-1.171V294.525h30.443Zm0-11.319H93.987l1.171-2.342h23.566Zm0-3.122H88.281v-1.171a1.169,1.169,0,0,1,1.171-1.171h28.1a1.169,1.169,0,0,1,1.171,1.171Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247841",
    "data-name": "Path 247841",
    d: "M839.452,641.4a1.951,1.951,0,1,0-1.952-1.951A1.952,1.952,0,0,0,839.452,641.4Zm0-3.122a1.171,1.171,0,1,1-1.171,1.171A1.169,1.169,0,0,1,839.452,638.281Z",
    transform: "translate(-726.582 -339.072)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247842",
    "data-name": "Path 247842",
    d: "M437.89,592.184h1.171v1.171a.387.387,0,0,0,.39.39h1.561a.387.387,0,0,0,.39-.39v-1.171h.781v.39a.39.39,0,0,0,.781,0v-.39h5.675a3.513,3.513,0,1,0,0-2.342H437.89a.387.387,0,0,0-.39.39v1.561A.387.387,0,0,0,437.89,592.184Zm.39-1.561h10.647a.378.378,0,0,0,.375-.289,2.732,2.732,0,1,1,0,1.358.391.391,0,0,0-.375-.289h-7.915a.387.387,0,0,0-.39.39v1.171h-.781v-1.171a.387.387,0,0,0-.39-.39h-1.171Z",
    transform: "translate(-339.072 -290.633)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247843",
    "data-name": "Path 247843",
    d: "M212.89,592.184h4.684a.387.387,0,0,0,.39-.39v-3.9a.387.387,0,0,0-.39-.39H212.89a.387.387,0,0,0-.39.39v3.9A.387.387,0,0,0,212.89,592.184Zm.39-3.9h3.9V591.4h-3.9Z",
    transform: "translate(-121.098 -290.633)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247844",
    "data-name": "Path 247844",
    d: "M262.89,637.5a.387.387,0,0,0-.39.39v.781a.39.39,0,1,0,.781,0v-.781A.386.386,0,0,0,262.89,637.5Z",
    transform: "translate(-169.535 -339.072)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247845",
    "data-name": "Path 247845",
    d: "M312.89,637.5a.386.386,0,0,0-.39.39v.781a.39.39,0,1,0,.781,0v-.781A.386.386,0,0,0,312.89,637.5Z",
    transform: "translate(-217.975 -339.072)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247846",
    "data-name": "Path 247846",
    d: "M587.5,716.793a.387.387,0,0,0,.39.39h13.27a1.169,1.169,0,0,0,1.171-1.171V712.89a.39.39,0,1,0-.781,0v3.122a.386.386,0,0,1-.39.39H587.89A.387.387,0,0,0,587.5,716.793Z",
    transform: "translate(-484.389 -411.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247847",
    "data-name": "Path 247847",
    d: "M1037.89,639.061a.387.387,0,0,0,.39-.39v-.781a.39.39,0,1,0-.781,0v.781A.387.387,0,0,0,1037.89,639.061Z",
    transform: "translate(-920.338 -339.072)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247848",
    "data-name": "Path 247848",
    d: "M138.671,668.745h1.561a.39.39,0,1,0,0-.781h-1.561a.387.387,0,0,1-.39-.39V662.89a.39.39,0,1,0-.781,0v4.684A1.169,1.169,0,0,0,138.671,668.745Z",
    transform: "translate(-48.439 -363.291)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247849",
    "data-name": "Path 247849",
    d: "M263.671,837.5h-.781a.39.39,0,1,0,0,.781h.781a.39.39,0,1,0,0-.781Z",
    transform: "translate(-169.535 -532.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247850",
    "data-name": "Path 247850",
    d: "M338.671,837.5h-.781a.39.39,0,1,0,0,.781h.781a.39.39,0,1,0,0-.781Z",
    transform: "translate(-242.193 -532.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247851",
    "data-name": "Path 247851",
    d: "M412.89,838.281h.781a.39.39,0,0,0,0-.781h-.781a.39.39,0,0,0,0,.781Z",
    transform: "translate(-314.852 -532.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247852",
    "data-name": "Path 247852",
    d: "M513.164,837.678a.278.278,0,0,0-.125-.086.391.391,0,0,0-.3,0,.278.278,0,0,0-.125.086.366.366,0,0,0-.117.273.316.316,0,0,0,.031.148.416.416,0,0,0,.211.211.317.317,0,0,0,.148.031.338.338,0,0,0,.148-.031.278.278,0,0,0,.125-.086.366.366,0,0,0,.117-.273.338.338,0,0,0-.031-.148A.277.277,0,0,0,513.164,837.678Z",
    transform: "translate(-411.73 -532.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247853",
    "data-name": "Path 247853",
    d: "M207.405,337.5H187.89a.39.39,0,0,0,0,.781h19.515a.39.39,0,0,0,0-.781Z",
    transform: "translate(-96.877 -48.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247854",
    "data-name": "Path 247854",
    d: "M891.013,337.5H887.89a.39.39,0,0,0,0,.781h3.122a.39.39,0,1,0,0-.781Z",
    transform: "translate(-775.021 -48.439)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeycard);
export default __webpack_public_path__ + "static/media/keycard.c759d167572404f4c941925d9c5b8892.svg";
export { ForwardRef as ReactComponent };